










































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { getSeedKpDetail, getSeedKpList, setKpField, updateKpField, getCompanyKpList, addKpToCompany, sourceSynchronize } from '@/api/kp';
import { startupMaturityList, CEOSuitabilityList, maintenanceStrategyList, kpProjectColumns } from '@/utils/kp';

import { search, searchNickName, searchNickNamePage } from '@/api/common.js';

import selectMember from '@/components/project/selectMember.vue';
import kpEdit from '@/components/kp/kpEdit.vue';
import kpTableItem from '@/components/kp/kpTableItem.vue';
import projectKpBind from '@/components/project/projectKpBind.vue';

import moment from 'moment';

@Component({
  components: {
    selectMember,
    kpEdit,
    kpTableItem,
    projectKpBind
  }
})
class projectKp extends Vue {
  columns: any[] = kpProjectColumns;
  data: any[] = [];
  showKpEdit: boolean = false;
  moment: any = moment;

  tableLoading: boolean = true;
  confirmLoading: boolean = false;

  kpEditType: string = 'bind';

  showDevelopment: boolean = false;
  developmentNow: string = '';
  developmentUser: string = '';
  developmentId: number = 0;

  pageInfo: object = {
    page: 1,
    pageSize: 10,
    total: 0
  };

  startupMaturityList: Array<string> = startupMaturityList;
  CEOSuitabilityList: Array<string> = CEOSuitabilityList;
  maintenanceStrategyList: Array<string> = maintenanceStrategyList;

  sourceList: Array<object> = [{ id: 1, name: 'seed公客池' }];

  // kpEdit: boolean = false;
  kpListTmp: Array<object> = []; // 传入projectKpBind的
  kpList: Array<object> = []; // 最后提交的

  kpSynchronize: boolean = false;

  labelCol: object = { span: 7 };
  wrapperCol: object = { span: 16 };

  // 新建KP
  form: object = {
    name: '',
    position: '',
    educationExperience: '',
    workExperience: '',
    individuality: ''
  };
  // 同步到seed
  form2: object = {
    maintainer: undefined,
    CEOSuitability: '待定',
    maintenanceStrategy: '待定',
    startupMaturity: '待定',
    source: 1,
    kpId: undefined
  };

  maintainerTmp: Array<object> = []; // 选人组件选主负责人
  kpInfoTmp: object = {}; // 保留编辑前的信息

  created() {
    this.getList();
  }

  // transform str to DOM and return the innerText of the DOM
  getText(str) {
    let div = document.createElement('div');
    div.innerHTML = str;
    return div.innerText;
  }

  async getList() {
    try {
      let body = { page: this.pageInfo['page'], pageSize: this.pageInfo['pageSize'] };
      this.tableLoading = true;
      let res = await getCompanyKpList({ companyId: this.$route.query.id, ...body });
      if (res.code === 200) {
        this.data = res.data.list;
        this.tableLoading = false;
        this.pageInfo['total'] = res.data.total;
      }
    } catch (err) {
      console.log(err);
    }
  }

  // 切换分页
  pageChange(page, pageSize) {
    this.pageInfo['page'] = page;
    this.pageInfo['pageSize'] = pageSize;
    this.getList();
  }

  // 跳转KP详情
  toDetail(id) {
    window.open(window.location.origin + `/kp/seed/detail?id=${id}`);
  }

  // 提交动态
  async submitDevelopment(row) {
    this.confirmLoading = true;

    let res = await setKpField({
      kpId: this.developmentId,
      source: 2,
      latestDevelopment: this.developmentNow
    });

    if (res.code === 200) {
      this.$message.success('提交成功!');
      this.developmentNow = '';
      this.getList();
      this.showDevelopment = false;
    }
    this.confirmLoading = false;
  }

  openDevelopment(row) {
    this.developmentId = row.baseInfo.id;
    this.developmentUser = row.baseInfo.name;
    this.showDevelopment = true;
  }

  openKpEdit(row, type) {
    if (type === 'new') {
      if (this.kpList.length === 0) {
        this.kpListTmp = [
          {
            kp: undefined,
            kpId: undefined,
            kpName: undefined,
            position: '' // 职位
          }
        ];
      } else {
        this.kpListTmp = this.kpList.map(item => {
          return {
            kp: item['kp'],
            position: item['position'] // 职位
          };
        });
      }

      this.kpEditType = 'bind';
      this.showKpEdit = true;
    } else if (type === 'edit') {
      this.kpInfoTmp = row;
      this.form = {
        name: row.baseInfo.name,
        position: row.position.value,
        educationExperience: this.getText(row.educationExperience.value),
        workExperience: this.getText(row.workExperience.value),
        individuality: this.getText(row.individuality.value)
      };
      this.kpEditType = 'edit';
      this.showKpEdit = true;
    }
  }

  openSynchronize(row) {
    this.form2['kpId'] = row.baseInfo.id;
    this.kpSynchronize = true;
  }

  hideKpEdit(type) {
    this.showKpEdit = false;
    if (type !== 'cancel') {
      this.getList();
    }
  }

  async handleEditOk(e) {
    try {
      if (this.kpEditType === 'bind') {
        // @ts-ignore
        this.$refs.kpEdit.submit();
      } else if (this.kpEditType === 'new') {
        // 新建kp
        if (!this.form['name']) {
          throw new Error('请填写客户姓名');
        } else if (!this.form['position']) {
          throw new Error('请填写职位');
        }
        // @ts-ignore
        let { educationExperience, individuality, name, workExperience, position } = this.form;
        this.confirmLoading = true;
        let res = await setKpField({
          educationExperience,
          individuality,
          name,
          workExperience,
          source: 2
        });

        // 绑定职位&公司
        let res2 = await addKpToCompany({
          kpId: res.data,
          companyId: this.$route.query.id,
          action: 1,
          position: position
        });
        this.confirmLoading = false;

        if (res.code === 200 && res2.code === 200) {
          this.form = {
            name: '',
            position: '',
            educationExperience: '',
            workExperience: '',
            individuality: ''
          };
          this.$message.success('创建成功!');
          this.showKpEdit = false;
          this.getList();
        }
      } else if (this.kpEditType === 'edit') {
        if (!this.form['name']) {
          throw new Error('请填写客户姓名');
        } else if (!this.form['position']) {
          throw new Error('请填写职位');
        }
        //@ts-ignore
        let { baseInfo, educationExperience, workExperience, individuality } = this.kpInfoTmp;
        let body = {};
        body[educationExperience.id] = this.form['educationExperience'];
        body[workExperience.id] = this.form['workExperience'];
        body[individuality.id] = this.form['individuality'];

        let res = await Promise.all([
          updateKpField({
            ...body
          }),
          setKpField({
            source: 2,
            kpId: baseInfo.id,
            name: this.form['name']
          }),
          addKpToCompany({
            kpId: baseInfo.id,
            companyId: this.$route.query.id,
            action: 1,
            position: this.form['position']
          })
        ]);

        if (res.every(e => e.code === 200)) {
          this.form = {
            name: '',
            position: '',
            educationExperience: '',
            workExperience: '',
            individuality: ''
          };
          this.showKpEdit = false;
          this.$message.success('编辑成功');
          this.getList();
        }
      }
      this.confirmLoading = false;
    } catch (err) {
      console.log(err);
      this.$message.error(err.message);
      this.confirmLoading = false;
    }
  }

  handleEditCancel(e) {
    this.showKpEdit = false;
    this.kpListTmp = [];
    this.kpList = [];
  }

  async handleSynchronizeOk() {
    try {
      // 校验必填
      if (!this.form2['maintainer']) {
        throw new Error('请填写主负责人');
      }
      // 先添加字段
      this.confirmLoading = true;

      let res = await setKpField({
        // source: 2,
        ...this.form2,
        maintainerAid: ''
      });

      // 在同步到seed
      let res2 = await sourceSynchronize({
        source: this.form2['source'],
        kpId: this.form2['kpId']
      });
      if (res2.code === 200) {
        this.form2 = {
          maintainer: undefined,
          CEOSuitability: '待定',
          maintenanceStrategy: '待定',
          startupMaturity: '待定',
          source: 1,
          kpId: undefined
        };
        this.maintainerTmp = [];
        this.$message.success('同步成功!');
        this.kpSynchronize = false;
        this.getList();
      }
      this.confirmLoading = false;
    } catch (error) {
      this.$message.error(error.message);
    }
  }

  handleSynchronizeCancel() {
    this.kpSynchronize = false;
  }

  fail(msg) {
    this.$message.error(msg);
  }

  async success(list) {
    try {
      this.showKpEdit = false;
      this.kpList = list;
      this.confirmLoading = true;

      let res = await Promise.all(
        this.kpList.map(i =>
          addKpToCompany({
            kpId: i['kpId'],
            companyId: this.$route.query.id,
            action: 1,
            position: i['position']
          })
        )
      );
      this.confirmLoading = false;
      this.kpListTmp = [];
      this.kpList = [];

      if (res.every(item => item.code === 200)) {
        this.$message.success('添加成功!');
        this.getList();
      } else {
        this.$message.error('添加失败!');
      }
    } catch (error) {
      console.log(error);
    }
  }

  async unbindKp(id) {
    try {
      let res = await addKpToCompany({
        kpId: id,
        companyId: this.$route.query.id,
        action: 2
      });
      if (res.code === 200) {
        this.$message.success('解绑成功!');
        this.getList();
      }
    } catch (err) {
      console.log(err);
    }
  }

  showUnbind(row) {
    let _this = this;
    this.$confirm({
      title: '解绑KP',
      width: 500,
      content: '解绑仅代表客户资源和项目解绑。是否需要解绑？',
      onOk() {
        _this.unbindKp(row.baseInfo.id);
      },
      onCancel() {},
      class: 'test'
    });
  }

  choseMaintainer(members, type) {
    if (type === 'maintainer') {
      this.maintainerTmp = members;
      this.form2['maintainer'] = this.maintainerTmp[0]['id'];
    }
  }

  delMaintainer(user, type) {
    if (type === 'maintainer') {
      this.maintainerTmp = [];
      this.form2['maintainer'] = undefined;
    }
  }
}

export default projectKp;
